<template>
	<b-card class="sa-card" header="" header-tag="header" footer-tag="footer" title="">
		<b-row>
			<b-col cols="12" xs="12" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Attivita:</label>
				<b-form-select v-model="jsonData.idAttivita" :options="attivitaOptions" :value="''" value-field="id" text-field="nome">
					<template #first>
						<b-form-select-option :value="null" disabled> - Seleziona Priorita - </b-form-select-option>
					</template>
				</b-form-select>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
				<label class="sa-label-data">Nome:</label>
				<b-form-input v-model="jsonData.nome"></b-form-input>
			</b-col>
			<b-col cols="12" xs="12" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Priorità:</label>
				<b-form-select v-model="jsonData.codicePriorita" :options="tipoPrioritaOptions" :value="''" value-field="codice" text-field="descrizione">
					<template #first>
						<b-form-select-option :value="null" disabled> - Seleziona Priorita - </b-form-select-option>
					</template>
				</b-form-select>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
				<label class="sa-label-data">Tempo Stimato:</label>
				<b-form-input v-model="jsonData.tempoStimato"></b-form-input>
			</b-col>
			<b-col cols="12" xs="12" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Data Inizio Programmata:</label>
				<date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataInizioProgrammata" type="date"></date-picker>
			</b-col>
			<b-col cols="12" xs="12" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Data Fine Programmata:</label>
				<date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataFineProgrammata" type="date"></date-picker>
			</b-col>
			<b-col cols="12" xs="12" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Data/Ora Inizio:</label>
				<date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataOraInizio" type="date"></date-picker>
			</b-col>
			<b-col cols="12" xs="12" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Data/Ora Fine:</label>
				<date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataOraFine" type="date"></date-picker>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Descrizione:</label>
				<b-form-textarea v-model="jsonData.descrizione" rows="7"></b-form-textarea>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Note:</label>
				<b-form-textarea v-model="jsonData.note" rows="7"></b-form-textarea>
			</b-col>
		</b-row>
	</b-card>
</template>

<script>
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	components: { DatePicker },
	data() {
		return {
			id: null,
			pathResourceAttivita: "/gestioneattivitaattivita",
			pathResourcePriorita: "/gestioneattivitapriorita",
			pathResource: "/gestioneattivitatasks",
			attivitaOptions: [],
			tipoPrioritaOptions: [],
			jsonData: { idAttivita: null, nome: null, descrizione: null, codicePriorita: null, dataInizioProgrammata: null, dataFineProgrammata: null, dataOraInizio: null, dataOraFine: null, tempoStimato: 0 },
		};
	},
	mounted() {
		if (this.$route.path.includes("/gestioneattivita/tasks/edit")) {
			let params = { idTask: this.$route.params.id };
			this.init(params);
		}
	},
	watch: {
		jsonData: {
			handler(jsonData) {
				this.$emit("updateJsonData", jsonData);
			},
			deep: true,
		},
	},
	methods: {
		init(params) {
			console.log("INIT");
			this.id = params.idTask;
			this.loadAttivita();
			this.loadDataPriorita();
			if (this.id !== "-1") {
				this.loadData();
			} else {
				this.jsonData.idAttivita = params.idAttivita;
			}
		},
		getJsonDataTask() {
			return this.jsonData;
		},
		loadDataPriorita() {
			let me = this;
			UtilityMixin.methods.loadDataResources(me.pathResourcePriorita, {}, me.loadDataPrioritaSuccess, me.loadDataError);
		},
		loadDataPrioritaSuccess(resposne) {
			let me = this;
			me.tipoPrioritaOptions = resposne.data.data.list;
		},
		loadAttivita() {
			let me = this;
			UtilityMixin.methods.loadDataResources(me.pathResourceAttivita, {}, me.loadAttivitaSuccess, me.loadDataError);
		},
		loadAttivitaSuccess(response) {
			let me = this;
			me.attivitaOptions = response.data.data.list;
		},
		loadAttivitaTipiError(error) {
			console.log(error);
		},
		loadData() {
			let me = this;
			me.$emit("beforeLoadData");
			UtilityMixin.methods.loadDataResources(me.pathResource + "/" + me.id, {}, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.jsonData = response.data.data;
			me.$emit("afterLoadData");
		},
		loadDataError(error) {
			let me = this;
			console.log(error);
			me.$emit("afterLoadData");
		},
	},
};
</script>

<style></style>
